var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHipConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3114 8.84012C25.5034 7.00012 22.5514 6.97212 20.7154 8.77612C18.8794 10.5801 18.8554 13.5321 20.6594 15.3721C22.4634 17.2121 25.4194 17.2401 27.2554 15.4361C29.0914 13.6321 29.1154 10.6801 27.3114 8.84012ZM25.0674 14.0521C24.3954 14.4401 23.5314 14.4281 22.8674 14.0281C21.5554 13.2361 21.4114 11.5081 22.4234 10.5121C23.2994 9.65212 24.7074 9.66412 25.5714 10.5441C26.5674 11.5601 26.3954 13.2881 25.0674 14.0521Z",
    fill: "#5A03EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1521 18.8118C19.1961 20.8918 19.1681 24.2318 17.0881 26.2718C15.0081 28.3118 11.6681 28.2798 9.62407 26.1998C7.58007 24.1198 7.60807 20.7798 9.68807 18.7358C11.7641 16.6958 15.1081 16.7278 17.1481 18.8078",
    fill: "#5A03EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0799 15.4558L12.3999 25.0398L11.2559 23.9238L20.9319 14.3398L22.0799 15.4558Z",
    fill: "#5A03EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHipConnect);
export default __webpack_public_path__ + "static/media/HIP Connect.60b37b09fb886ba4c8487715be9c1c61.svg";
export { ForwardRef as ReactComponent };